<div class="gt-filter-container">
  <i class="fa fa-refresh gt-refresh" (click)="refresh()" style="cursor: pointer;" title="Refresh Data"></i>
</div>
<div class="list-wrapper">
  <div class="list-header">Efile List</div>
  <div class="list-content">
    @if (rowData?.tax_year) {
<div>Tax Year: {{ rowData.tax_year }}</div>
}
    @if (rowData?.type) {
<div>Type: {{ rowData.type }}</div>
}
    <div class="muted">Grid content is loaded from route/grid config in parent efile flow.</div>
  </div>
</div>
